import { createFileRoute } from "@tanstack/react-router";
import DepressionHub from "@/pages/DepressionHub";
export const Route = createFileRoute("/contents/conditions/depression/")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Overview | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Comprehensive information on major depressive disorder, symptoms, traditional vs. alternative treatments, and advanced neuromodulation in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Depression Overview | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Comprehensive information on major depressive disorder, symptoms, traditional vs. alternative treatments, and advanced neuromodulation in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/conditions/depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/conditions/depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionHub />;
}
